import unicodeRanges from "./unicode-ranges.json";

export const CATEGORY_WHITELIST = [
  "Basic Latin",
  "Latin-1 Supplement",
  "Latin Extended-A",
  "Latin Extended-B",
  "Greek and Coptic",
  "General Punctuation",
  "Superscripts and Subscripts",
  "Currency Symbols",
  "Arrows",
  "Mathematical Operators",
  "Miscellaneous Technical",
  "Enclosed Alphanumerics",
  "Geometric Shapes",
  "Miscellaneous Symbols",
  "Dingbats",
];
export const getAllCategories = () =>
  unicodeRanges
    .map((range) => range.category)
    .filter((category) => CATEGORY_WHITELIST.includes(category));

export function getCharactersByCategory() {
  const categoriesWithCharacters: Record<string, string[]> = {};

  unicodeRanges.forEach((entry) => {
    const { category, range } = entry;
    const characters = [];

    for (let i = range[0]; i <= range[1]; i++) {
      characters.push(String.fromCharCode(i));
    }

    categoriesWithCharacters[category] = characters;
  });

  return categoriesWithCharacters;
}
